import React from "react";
import { useFieldArray } from "react-hook-form";
import { SdsForm } from "soft_digi";
import { SdsFormElementProps } from "soft_digi/dist/sdforms/SdsFromInterFace";

interface HeaderProps {
  control: any;
  errors: any;
  watch: any;
  setValue: any;
  dataIn: any;
}

const CustomerSubForm: React.FC<HeaderProps> = ({
  control,
  errors,
  watch,
  setValue,
  dataIn,
}) => {
  const { fields, append, remove, replace } = useFieldArray({
    control,
    name: "sub_data",
  });

  React.useEffect(() => {
    if (dataIn?.sub_data && Array.isArray(dataIn.sub_data)) {

      replace(
        dataIn.sub_data.map((x: any) => ({
          sd_efl_hsns_id: x.sd_efl_hsns_id || "",
          hsn: x.hsn || "",
          title: x.title || "",
        }))
      );
    } else {
      if (fields.length === 0) {
        append({});
      }
    }
  }, [dataIn]);

  const options_hsn = [
    { value: "1", label: "Parking & Charging" },
    { value: "2", label: "Parking" },
    { value: "3", label: "Charging (AC)" },
    { value: "5", label: "Charging (DC)" },
    { value: "4", label: "Rent" },
    { value: "6", label: "Infra Sharing" },
    { value: "7", label: "Charging(Office)" },
    { value: "8", label: "Support Services" },
  ];

  const addRemoveButtons = (index: number): React.ReactNode => (
    <>
      <span className="icon">
        {index === fields.length - 1 && (
          <i
            className="fa fa-plus has-text-link smart-cursor"
            onClick={() => append({})}
          />
        )}
      </span>
      <span className="icon">
        {fields.length > 1 && (
          <i
            className="fa fa-trash has-text-danger smart-cursor"
            onClick={() => remove(index)}
          />
        )}
      </span>
    </>
  );

  const getElements = (index: number): SdsFormElementProps[] => {
    return [
      {
        type: "SELECT_BOX",
        width: 2,
        name: `sub_data.${index}.sd_efl_hsns_id`,
        element: {
          options: options_hsn,
          size: "small",
        },
      },
      {
        type: "TEXT_BOX",
        width: 3,
        name: `sub_data.${index}.hsn`,
        element: {
          size: "small",
          inputProps: {},
        },
      },
      {
        type: "TEXTAREA",
        width: 6,
        name: `sub_data.${index}.title`,
        element: {
          size: "small",
          inputProps: {},
        },
      },
      {
        type: "LABEL",
        width: 1,
        class_name: "has-text-centered p-2",
        name: `sub_data.${index}.addbuttons`,
        labelComponent: addRemoveButtons(index),
      },
    ];
  };

  return (
    <>
      <div className="column is-6">
        <span className="is-size-5 has-text-weight-bold">Bill Items:</span>
      </div>

      <div className="sd-hims-input sd-hims-batch-form">
        <div className="columns is-multiline">
          <div className="column is-3">Select Bill Item</div>
          <div className="column is-3">HSN</div>
          <div className="column is-6">Description</div>
        </div>

        {fields.map((field, index) => (
          <SdsForm
            key={field.id}
            elements={getElements(index)}
            errors={errors}
            control={control}
            className="mb-1"
          />
        ))}
      </div>
    </>
  );
};

export default CustomerSubForm;
